import graphql__7c0f8be76fc242d3b6a5 from "./__generated__/useCreateHubSpotContactMutation.graphql.ts";import graphql from 'babel-plugin-relay/macro'
import { useEffect, useState } from 'react'
import { useMutation } from 'react-relay/hooks'

import { useCreateHubSpotContactMutation } from './__generated__/useCreateHubSpotContactMutation.graphql'

const CreateHubSpotContactMutation = graphql__7c0f8be76fc242d3b6a5

/** Hook used to create HubSpot contact for a current user. */
const useCreateHubSpotContact = (viewerId: string | null = null): string => {
  const [createHubSpotContact] = useMutation<useCreateHubSpotContactMutation>(
    CreateHubSpotContactMutation,
  )
  const [contactId, setContactId] = useState('')

  useEffect(() => {
    if (viewerId) {
      createHubSpotContact({
        variables: {},
        onCompleted(data) {
          setContactId(data?.createHubspotContact?.hubspotContactId)
        },
      })
    }
  }, [viewerId]) // eslint-disable-line react-hooks/exhaustive-deps

  return contactId
}

export default useCreateHubSpotContact
